import { PersonalRecord, ServerRecord } from '../../server/mate/ServerRecord';
import { getCurrentConference, getGroupId } from "../base/conference";
import { getLocalParticipantId, setRecordingParticipant } from "../base/participants";
import { StateListenerRegistry } from "../base/redux";
import { getAudioTrackInGroup } from '../base/tracks';
import { setRecordingEnabled } from "./actions";
import { RECORDING_TYPE } from "./constants";

let personalClass = null;
let serverClass = null;
// 오디오 추가 사용자 
StateListenerRegistry.register(state => getAudioTrackInGroup(state, true), 
    (audioTracks, { getState }) => {
        const tracks = new Map();
        audioTracks.map(t => tracks.set(t.track.stream.id, t.track));

        personalClass && personalClass.connectAudio(tracks);
        serverClass && serverClass.connectAudio(tracks);
    }, {
        deepEquals: true
    });

// 그룹 
StateListenerRegistry.register(state => getGroupId(state), 
    (groupId, store) => {
        personalUnload();
        serverUnload();
    });

const personalUnload = () => {
    if (personalClass) {
        personalClass.stop();
        personalClass = null;
    }
}
const serverUnload = () => {
    if (serverClass) {
        serverClass.stop();
        serverClass = null;
    }
}

const unload = (type) => {
    if (type === true || type === RECORDING_TYPE.PERSONAL) personalUnload();
    if (type === true || type === RECORDING_TYPE.SERVER) serverUnload();
}

// 회의실 종료된 경우 
StateListenerRegistry.register(state => getCurrentConference(state),
    (conference, store) => {
        if (!conference) unload(true);
    }
)

const setRecordParticipant = (isRecord, type = null) => {
    const { getState, dispatch } = APP.store;

    APP.UI.closeModal();

    const localId = getLocalParticipantId(getState()); 
    if (!isRecord) dispatch(setRecordingEnabled(type, false)); 

    dispatch(setRecordingParticipant(localId, isRecord));
    APP.mateManagement.setRecording(isRecord, localId);
}

// 개인 회의 
StateListenerRegistry.register(state => state['features/recording'][RECORDING_TYPE.SERVER].enabled,
    (isRecord, store) => {
        // 녹화 시작
        if (isRecord) {
            // 이미 진행중인 녹화가 존재 & 녹화 하라고 실행한 경우 
            if (serverClass) {
                // 진행 중이던 녹화 종료 후 녹화 시작 
                serverUnload();
            }

            window.addEventListener("beforeunload", serverUnload);
            
            serverClass = new ServerRecord({
                setRecordParticipant: (isRecord, type) => setRecordParticipant(isRecord, type)
            });

            const isSetRecord = serverClass.setRecord();            
            if (isSetRecord) {
                const audioTracks = new Map();
                getAudioTrackInGroup(store.getState(), true).map(t => audioTracks.set(t.track.stream.id, t.track));
                serverClass.startRecord(audioTracks);
            } else {
                alert("녹화를 지원하지 않는 브라우저입니다.");
                store.dispatch(setRecordingEnabled(RECORDING_TYPE.SERVER, false)); 
                serverUnload();
            }
        } else {
            serverUnload();
            window.removeEventListener("beforeunload", serverUnload);
        }
    });

StateListenerRegistry.register(state => state['features/recording'][RECORDING_TYPE.PERSONAL].enabled,
    (isRecord, store) => {
        // 녹화 시작
        if (isRecord) {
            // 이미 진행중인 녹화가 존재 & 녹화 하라고 실행한 경우 
            if (personalClass) {
                // 진행 중이던 녹화 종료 후 녹화 시작 
                personalUnload();
            }

            window.addEventListener("beforeunload", personalUnload);
            personalClass = new PersonalRecord({
                setRecordParticipant: (isRecord, type) => setRecordParticipant(isRecord, type)
            });

            const isSetRecord = personalClass.setRecord();
            if (isSetRecord) {
                const audioTracks = new Map();
                getAudioTrackInGroup(store.getState(), true).map(t => audioTracks.set(t.track.stream.id, t.track));

                personalClass.startRecord(audioTracks);
            } else {
                alert("녹화를 지원하지 않는 브라우저입니다.");
                store.dispatch(setRecordingEnabled(RECORDING_TYPE.PERSONAL, false)); 
                personalUnload();
            }
        } else {
            personalUnload();
            window.removeEventListener("beforeunload", personalUnload);
        }
    });